const formatDaysFromNow = (date) => {
    const now = new Date();
    const dateToCount = new Date(date);
    const difference = now.getTime() - dateToCount.getTime();
    const differenceInDays = difference / (1000 * 3600 * 24);
    return Math.round(differenceInDays);
};

export default formatDaysFromNow;
